import React, { createContext, useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";
import { useGetMachineById } from "../services/machine";

export const MachineContext = createContext();
export const useMachineContext = () => useContext(MachineContext);
const MachineProvider = ({ children }) => {
  let washProgram = [
    {
      id: 1,
      label: {
        th: "น้ำเย็น",
      },
    },
    {
      id: 2,
      label: {
        th: "น้ำอุ่น",
      },
    },
    {
      id: 3,
      label: {
        th: "น้ำร้อน",
      },
    },
  ];

  let dryProgram = [
    {
      id: 1,
      label: {
        th1: "ไม่เพิ่มเวลาอบ",
        th2: ""
      },
    },
    {
      id: 2,
      label: {
        th1: "เพิ่มเวลาอบ",
        th2: "10 บาท 5 นาที"
      },
    },
    {
      id: 3,
      label: {
        th1: "เพิ่มเวลาอบ",
        th2: "20 บาท 10 นาที"
      },
    },
    {
      id: 4,
      label: {
        th1: "เพิ่มเวลาอบ",
        th2: "30 บาท 15 นาที"
      },
    },
  ];

  let [
    [
      {
        data: machineData,
        loading: loadingMachineData,
        error: errorMachineData,
      },
      fetchMachineData,
    ],
    getMachineDataUrl,
  ] = useGetMachineById();

  // No program pre-selected — user must actively choose before "ตกลง" enables
  const [machineProgram, setMachineProgram] = useState(null);
  const [machineId, setMachineId] = useState();
  const [coupon, setCoupon] = useState();
  const [totalPrice, setTotalPrice] = useState(0);
  const [summary, setSummary] = useState({
    machinePrice: machineData?.machine?.machine_price,
    machineDuration: machineData?.machine?.machineDuration,
    benefit: "Silver",
    benefitDiscount: 0,
    pointDiscount: 0,
    couponDiscount: coupon ? coupon.value : 0,
  });
  let state = {
    machineProgram,
    washProgram,
    dryProgram,
    machineProgram,
    machineData,
    loadingMachineData,
    coupon,
    setSummary,
    summary: { ...summary, totalPrice },
  };
  let action = {
    setCoupon: (coupon) => {
      setCoupon(coupon);
    },
    setMachineProgram: (program) => {
      setMachineProgram(program);
    },

    setMachineId: (id) => {
      setMachineId(id);
    },
    setSummary,
    refetchMachineData: () => {
      if (machineId) {
        fetchMachineData({
          url: getMachineDataUrl(machineId),
        }).catch((error) => {});
      }
    }
  };

  useEffect(() => {
    if (machineId) {
      fetchMachineData({
        url: getMachineDataUrl(machineId),
      }).catch((error) => {});
    }
  }, [machineId]);
  useEffect(() => {
    if (coupon) {
      setSummary((prev) => {
        return { ...prev, couponDiscount: coupon.value };
      });
    }
  }, [coupon]);
  useEffect(() => {
    if (machineData) {
      setSummary((prev) => {
        return { ...prev, machinePrice: machineData?.machine?.machine_price };
      });
    }
  }, [machineData]);

  useEffect(() => {
    if (summary) {
      let price =
        summary.machinePrice -
        (summary.couponDiscount +
          summary.benefitDiscount +
          summary.pointDiscount);
      setTotalPrice(price > 0 ? price : 0);
    }
    console.log(summary.machinePrice);
  }, [summary]);
  return (
    <MachineContext.Provider value={{ ...action, ...state }}>
      {children}
    </MachineContext.Provider>
  );
};

export default MachineProvider;
